import { useEffect } from "react";
import { ResizeObserver } from "@juggle/resize-observer";
import type { Form } from "@/react/types/Form";

const calculateContentHeight = () => {
  const body = document.body;
  const html = document.documentElement;
  return Math.max(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight,
  );
};

interface UseAdjustFormHeightProps {
  form?: Form | null;
  index: number;
  isModal: boolean;
}
export const useAdjustFormHeight = ({
  form,
  index,
  isModal,
}: UseAdjustFormHeightProps) => {
  useEffect(() => {
    if (!form || isModal) return;

    const resizeObserver = new ResizeObserver(() => {
      const height = calculateContentHeight();
      // eslint-disable-next-line sonarjs/post-message -- Disabled for plugin version update. Fix when possible.
      window.parent.postMessage(
        {
          type: "resize",
          formUid: form.uid,
          formIndex: index,
          height: `${height}px`,
        },
        "*",
      );
    });

    const formElement = document.getElementById(`form-${form.uid}`);

    if (!formElement) return;

    resizeObserver.observe(formElement);
    return () => resizeObserver.disconnect();
  }, [form, index]);

  return null;
};
